import type { ReactNode } from "react";

import { ReactComponent as GuardIcon } from "../../../assets/notifications/guardIcon.svg";
import { ReactComponent as WarnIcon } from "../../../assets/notifications/warnIcon.svg";
import { insufficientLamports, slippageExceeded, transactionRejectedByUser } from "../../../constants/regex";

export type KnownError = {
  searchObject: string | RegExp;
  notificationMessage: string;
  notificationDescription: ReactNode;
  icon?: ReactNode;
};

export const knownPreSendErrors: KnownError[] = [
  {
    searchObject: transactionRejectedByUser,
    notificationMessage: "You declined this transaction",
    notificationDescription: "You declined this transaction in your wallet, or the transaction has timed out.",
  },
  {
    searchObject: "not been authorized by the user",
    notificationMessage: "Wallet signature error",
    notificationDescription: "Your wallet has partially disconnected. Please reconnect your wallet, and try again.",
  },
  {
    searchObject: "was not confirmed in",
    notificationMessage: "Transaction has timed out",
    notificationDescription:
      "It is unknown if your transaction has confirmed or failed. Check the transaction status by clicking the link below.",
  },
  {
    searchObject: "unknown signer",
    notificationMessage: "Wallet signature error",
    notificationDescription: "Disconnect and reconnect your wallet, and try again.",
  },
  {
    searchObject: "no unsettled funds",
    notificationMessage: "There are no unsettled funds",
    notificationDescription: "",
  },
];

export const knownPostSendErrors: KnownError[] = [
  {
    searchObject: slippageExceeded,
    notificationDescription: (
      <>
        <span>
          The rate on this swap changed before the transaction could complete, so the swap has been cancelled to protect
          your funds.
        </span>
        <span>Try swapping again.</span>
      </>
    ),
    notificationMessage: "Your slippage has been exceeded",
    icon: <GuardIcon />,
  },
  {
    searchObject: insufficientLamports,
    notificationMessage: "You don't have enough SOL",
    notificationDescription: "SOL is needed to pay for transactions. Send SOL to this address, and try again.",
    icon: <WarnIcon />,
  },
];
